import React, { useState } from 'react';
import { api } from '../../services/api';
import './login.css';

const Login = ({ onAuthenticated, setAuthLoading, authError, setAuthError }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const login = async () => {
    if (!username || !password) {
      setAuthError("Username and password are required.");
      return;
    }
    setAuthError("");
    setAuthLoading(true);
    try {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("expiresIn");
      const params = { username, password };
      const queryString = new URLSearchParams(params).toString();
      const url = `/api/admin/authenticate?${queryString}`;
      const response = await api.get(url);
      const token = response.data.accessToken;
      const expiresIn = response.data.expiresIn;
      localStorage.setItem("accessToken", token);
      localStorage.setItem("expiresIn", expiresIn);
      onAuthenticated(token);
    } catch (error) {
      console.error("Login failed:", error);
      if (error.response && error.response.status === 401) {
        setAuthError("Login failed. Please check your credentials");
      } else {
        setAuthError("An error occurred during login. Please try again.");
      }
    } finally {
      setAuthLoading(false);
    }
  };

  return (
    <div className="login">
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          width: "100%",
          maxWidth: "400px",
          margin: "0 auto"
        }}
        onSubmit={e => { e.preventDefault(); login(); }}
      >
        <h2>Login</h2>
        <input
          value={username}
          onChange={e => setUsername(e.target.value)}
          placeholder="Username"
        />
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          placeholder="Password"
        />
        <button type="submit">Login</button>
        <div style={{ minHeight: "1.5em" }}>
          {authError && <div className="login-error">{authError}</div>}
        </div>
      </form>
    </div>
  );
};

export default Login;